<template>
  <div class="supplyDemand-setting">
    <ContentBlock class="leftContainer">
      <div
        v-for="(tab, index) in tabList"
        :key="'tab'+index"
        @click="checkTab(tab.value)"
        :class="{'tab': true,'active': active === tab.value}">
        <img :src="active === tab.value ? tab.icon : tab.defaultIcon" class="tab-icon" />
        <span>{{ tab.label }}</span>
      </div>
    </ContentBlock>
    <div class="rightContainer">
      <ContentBlock v-if="info.id">
        <QuotePriceSetting v-if="active ==='quotePrice' && !userInfo.isPersonal" :baseInfo="info" />
        <LinkSetting v-show="active === 'link'" ref="linkSettingRef" />
        <MarketDetail v-if="active === 'market'" />
        <SaleOrder v-if="active === 'saleOrder'" />
      </ContentBlock>
    </div>
  </div>
</template>
<script>
import QuotePriceSetting from './components/quotePriceSetting.vue';
import LinkSetting from './components/linkSetting.vue';
import MarketDetail from './components/marketDetail.vue';
import SaleOrder from './components/saleOrderSetting.vue';
import { tenantDetail } from '@/api/shop';
export default {
  components: {
    QuotePriceSetting,
    LinkSetting,
    MarketDetail,
    SaleOrder,
  },
  data () {
    return {
      active: 'link',
      userInfo: JSON.parse(this.$local.get('userInfo')) || {},
      tabList: [
        {
          label: '对外联系方式设置',
          value: 'link',
          icon: require('@/assets/ic_link_set.svg'),
          defaultIcon: require('@/assets/ic_link_set_default.svg'),
        },
        {
          label: '云仓设置',
          value: 'market',
          icon: require('@/assets/ic_market_set.svg'),
          defaultIcon: require('@/assets/ic_market_set_default.svg'),
        },
      ],
      info: {},
    };
  },
  methods: {
    checkTab (v) {
      this.active = v;
    },
    async init () {
      const { body } = await tenantDetail({
        id: this.userInfo.tenantId,
        findBusinessAreaFlag: true,
        findEmployeeFlag: true,
        findInquirePriceTaskOrderUserNameFlag: true,
        findRegisterAuthenticationFlag: true,
        findTenantCertificateFlag: true,
      });
      this.info = body || {};
      this.$nextTick(() => {
        this.$refs.linkSettingRef.info = {
          tenantId: this.info.id,
          serviceTel: this.info.serviceTel,
        };
      });
    },
  },
  mounted () {
    if (!this.userInfo.isPersonal) {
      this.active = 'quotePrice';
      this.tabList.unshift(
        {
          label: '询单报价设置',
          value: 'quotePrice',
          icon: require('@/assets/ic_quote_set.svg'),
          defaultIcon: require('@/assets/ic_quote_set_default.svg'),
        },
      );
    } else {
      this.active = 'link';
    }
    if (!this.userInfo.isPersonal && this.userInfo.adminFlag) {
      this.tabList.push(
        {
          label: '销售订单确认设置',
          value: 'saleOrder',
          icon: require('@/assets/ic_saleorder_set.svg'),
          defaultIcon: require('@/assets/ic_saleorder_set_default.svg'),
        },
      );
    }
    this.init();
  },
};
</script>
<style lang="scss" scoped>
.supplyDemand-setting {
  display: flex;
  background: transparent;
  height: 100%;
  box-sizing: border-box;

  .leftContainer {
    box-sizing: border-box;
    width: 320px;
    display: flex;
    box-shadow: 0px 4px 6px 0px rgba(36, 40, 50, 0.08);
    border-radius: 4px;
    flex-direction: column;
    margin-right: 8px;
    background: #FFFFFF;
    padding: 10px 8px;

    .tab {
      border-radius: 4px;
      padding: 10px 12px;
      font-weight: 400;
      font-size: 14px;
      color: #1F2733;
      cursor: default;

      &.active {
        background: #E2F3FE;
        font-weight: 600;
        color: #237FFA;
      }

      .tab-icon {
        width: 16px;
        height: 16px;
        margin-right: 8px;
      }
    }
  }

  .rightContainer {
    width: 100%;
    display: flex;
    flex-direction: column;

    .content_block {
      padding: 0 10px;
      padding-bottom: 20px;
      border-radius: 4px;
      flex: 1;
    }
  }
}
</style>
